/* Homefield sections for Shopify Horizon
   - <hf-bead>             play / pause for the ingredient video
   - <hf-product-builder>  scent + bundle + purchase-type builder for the PDP
   Safe to load more than once on a page. */
(function () {
  if (window.__hfLoaded) return;
  window.__hfLoaded = true;

  /* ---------------- Money ---------------- */
  function groupDigits(n, decimals, thousands, decimal) {
    var parts = (n / 100).toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
  }
  function formatMoney(cents, format, trimZeros) {
    cents = Math.round(Number(cents) || 0);
    format = format || '${{amount}}';
    var showDecimals = !(trimZeros && cents % 100 === 0);
    var map = {
      amount: function () { return groupDigits(cents, showDecimals ? 2 : 0, ',', '.'); },
      amount_no_decimals: function () { return groupDigits(cents, 0, ',', '.'); },
      amount_with_comma_separator: function () { return groupDigits(cents, showDecimals ? 2 : 0, '.', ','); },
      amount_no_decimals_with_comma_separator: function () { return groupDigits(cents, 0, '.', ','); },
      amount_with_apostrophe_separator: function () { return groupDigits(cents, showDecimals ? 2 : 0, "'", '.'); },
      amount_with_space_separator: function () { return groupDigits(cents, showDecimals ? 2 : 0, ' ', ','); }
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      return (map[key] || map.amount)();
    });
  }
  function fill(template, tokens) {
    return String(template || '').replace(/\{(\w+)\}/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(tokens, k) ? tokens[k] : m;
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------------- Bead video toggle ---------------- */
  if (!customElements.get('hf-bead')) {
    customElements.define('hf-bead', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.btn = this.querySelector('[data-hf-motion]');
        if (!this.btn) return;
        this.labelPlay = this.btn.getAttribute('data-label-play') || 'Play animation';
        this.labelPause = this.btn.getAttribute('data-label-pause') || 'Pause animation';
        // Same behavior as the prototype: plays when on screen, pauses when scrolled away,
        // remembers if the shopper paused it, and stays paused for reduced-motion users.
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.userPaused = !this.hasAttribute('data-autoplay') || !!reduce;
        this.setButton(false);
        this.btn.addEventListener('click', () => {
          if (this.playing) { this.userPaused = true; this.pause(); }
          else { this.userPaused = false; this.play(); }
        });
        if (this.video) {
          this.video.addEventListener('ended', () => { if (!this.userPaused) this.play(); });
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver((entries) => {
              if (entries[0].isIntersecting && !this.userPaused) this.play();
              else this.pause();
            }, { threshold: 0.15 });
            this.io.observe(this.video);
          }
        }
      }
      disconnectedCallback() { if (this.io) this.io.disconnect(); }
      setButton(playing) {
        this.playing = playing;
        this.classList.toggle('is-paused', !playing);
        this.btn.innerHTML = playing
          ? esc(this.labelPause) + ' <span aria-hidden="true">&#8545;</span>'
          : esc(this.labelPlay) + ' <span aria-hidden="true">&#9655;</span>';
        this.btn.setAttribute('aria-label', playing ? this.labelPause : this.labelPlay);
      }
      play() {
        if (!this.video) { this.setButton(true); return; }
        this.video.muted = true;
        var p = this.video.play();
        if (p && p.then) p.then(() => this.setButton(true)).catch(() => this.setButton(false));
        else this.setButton(true);
      }
      pause() {
        if (this.video) this.video.pause();
        this.setButton(false);
      }
    });
  }

  /* ---------------- Product builder ---------------- */
  if (!customElements.get('hf-product-builder')) {
    customElements.define('hf-product-builder', class extends HTMLElement {
      connectedCallback() {
        var cfgEl = this.querySelector('script[data-hf-config]');
        if (!cfgEl) return;
        try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.error('[Homefield] Bad config', e); return; }
        this.product = this.cfg.product;
        this.s = this.cfg.settings;
        this.scents = this.cfg.scents.length ? this.cfg.scents : [{ key: 'default', name: '', value: '', desc: '', image: '', swatch: '#ddd' }];
        this.packs = this.cfg.packs.length ? this.cfg.packs : [{ count: 1, label: '', chip: '', match: '', upgradeHeading: '' }];
        this.scentOptionIndex = this.findOptionIndex(this.s.scentOptionName);

        this.setupSubscriptions();
        this.initState();
        this.bind();
        this.update();
        this.setupSticky();
      }

      disconnectedCallback() { if (this.stickyObserver) this.stickyObserver.disconnect(); }

      $(sel) { return this.querySelector(sel); }
      $$(sel) { return Array.prototype.slice.call(this.querySelectorAll(sel)); }
      money(c) { return formatMoney(c, this.cfg.moneyFormat, this.s.trimZeros); }

      findOptionIndex(name) {
        if (!name || !this.product || !this.product.options) return -1;
        var n = String(name).trim().toLowerCase();
        for (var i = 0; i < this.product.options.length; i++) {
          var o = this.product.options[i];
          var oname = typeof o === 'string' ? o : (o && o.name);
          if (String(oname || '').trim().toLowerCase() === n) return i;
        }
        return -1;
      }

      /* Subscriptions:
         - LIVE: product has selling plans from a subscription app -> real plans are used.
         - PREVIEW: no plans, but we are inside the theme editor -> styled preview only.
         - OFF: no plans on the live store -> subscribe option is hidden, one-time only. */
      setupSubscriptions() {
        var groups = (this.product && this.product.selling_plan_groups) || [];
        var plans = [];
        groups.forEach(function (g) { (g.selling_plans || []).forEach(function (p) { plans.push({ id: p.id, name: p.name }); }); });
        if (this.s.showSubscription && plans.length) {
          this.subMode = 'live';
          this.plans = plans;
        } else if (this.s.showSubscription && this.cfg.designMode) {
          this.subMode = 'preview';
          this.plans = (this.s.previewCadences || []).map(function (name) { return String(name).trim(); }).filter(Boolean).map(function (name, i) { return { id: 'preview-' + i, name: name }; });
        } else {
          this.subMode = 'off';
          this.plans = [];
        }
        this.requiresPlan = !!(this.product && this.product.requires_selling_plan) && this.subMode === 'live';

        var select = this.$('[data-hf-cadence]');
        if (select) {
          select.innerHTML = this.plans.map(function (p) { return '<option value="' + esc(p.id) + '">' + esc(p.name) + '</option>'; }).join('');
        }
        var subOpt = this.$('[data-hf-sub-option]');
        var onceOpt = this.$('[data-hf-once-option]');
        var wrap = this.$('[data-hf-purchase-step]');
        if (this.subMode === 'off') {
          if (subOpt) subOpt.hidden = true;
          if (wrap && this.s.hideStepWhenOneTime) wrap.hidden = true;
        }
        if (this.requiresPlan && onceOpt) onceOpt.hidden = true;
        var note = this.$('[data-hf-preview-note]');
        if (note) note.hidden = this.subMode !== 'preview';
      }

      initState() {
        var url = new URL(window.location.href);
        var keys = this.scents.map(function (s) { return s.key; });
        var defaultMix = this.scents.map(function (s) { return s.key; });
        var maxCount = Math.max.apply(null, this.packs.map(function (p) { return p.count; }));
        while (defaultMix.length < maxCount) defaultMix.push(keys[defaultMix.length % keys.length]);

        var packIndex = 0;
        this.packs.forEach(function (p, i) { if (p.isDefault) packIndex = i; });

        var paramScent = url.searchParams.get('scent');
        if (paramScent && keys.indexOf(paramScent) > -1) defaultMix[0] = paramScent;
        var paramPack = Number(url.searchParams.get('pack'));
        if (paramPack) {
          var found = this.packs.findIndex(function (p) { return p.count === paramPack; });
          if (found > -1) packIndex = found;
        }

        // If the URL already points at a variant (e.g. ?variant=123) honor its scent/pack
        var vid = Number(url.searchParams.get('variant'));
        if (vid && this.product) {
          var v = this.product.variants.find(function (x) { return x.id === vid; });
          if (v) {
            if (this.scentOptionIndex > -1) {
              var sv = String(v.options[this.scentOptionIndex]).toLowerCase();
              var sc = this.scents.find(function (s) { return String(s.value || s.name).toLowerCase() === sv; });
              if (sc) defaultMix[0] = sc.key;
            }
          }
        }

        var mode = this.s.defaultPurchase === 'subscribe' && this.subMode !== 'off' ? 'subscribe' : 'once';
        if (this.requiresPlan) mode = 'subscribe';
        this.state = { mix: defaultMix, pack: packIndex, mode: mode, plan: this.plans[this.s.defaultPlanIndex] ? this.plans[this.s.defaultPlanIndex].id : (this.plans[0] && this.plans[0].id), gallery: 'product' };
      }

      bind() {
        var self = this;
        this.addEventListener('click', function (e) {
          var t = e.target.closest('[data-hf-scent],[data-hf-pack],[data-hf-thumb],[data-hf-upgrade],[data-hf-sticky-add]');
          if (!t || !self.contains(t)) return;
          if (t.hasAttribute('data-hf-scent')) { self.state.mix[0] = t.getAttribute('data-hf-scent'); self.state.gallery = 'product'; self.update(); }
          else if (t.hasAttribute('data-hf-pack')) { self.state.pack = Number(t.getAttribute('data-hf-pack')); self.update(); }
          else if (t.hasAttribute('data-hf-thumb')) { self.state.gallery = t.getAttribute('data-hf-thumb'); self.updateGallery(); }
          else if (t.hasAttribute('data-hf-upgrade')) { self.state.pack = Number(t.getAttribute('data-hf-upgrade')); self.update(); }
          else if (t.hasAttribute('data-hf-sticky-add')) { e.preventDefault(); self.addToCart(); }
        });
        this.addEventListener('change', function (e) {
          var t = e.target;
          if (t.matches('[data-hf-mix-select]')) { self.state.mix[Number(t.getAttribute('data-hf-mix-select'))] = t.value; self.update(); }
          else if (t.matches('input[name="hf-purchase-' + self.cfg.sectionId + '"]')) { self.state.mode = t.value; self.update(); }
          else if (t.matches('[data-hf-cadence]')) { self.state.plan = t.value; self.update(); }
        });
        var form = this.$('form.hf-form');
        if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.addToCart(); });
      }

      scent(key) { return this.scents.find(function (s) { return s.key === key; }) || this.scents[0]; }
      pack(i) { return this.packs[i == null ? this.state.pack : i]; }

      /* Inventory is tracked per scent: each scent is its own variant.
         A bundle adds one unit per canister (grouped by scent) and the bundle
         price comes from a Shopify automatic discount (set up in admin). The
         percent on each Bundle size block is only used to DISPLAY that price,
         so keep it equal to the discount you create in Shopify. */
      variantForScent(key) {
        var p = this.product;
        if (!p || !p.variants || !p.variants.length) return null;
        if (this.scentOptionIndex === -1) return p.variants[0];
        var sc = this.scent(key);
        var want = String(sc.value || sc.name).trim().toLowerCase();
        var idx = this.scentOptionIndex;
        return p.variants.find(function (v) { return String(v.options[idx]).trim().toLowerCase() === want; }) || p.variants[0];
      }

      canisters(packIndex) {
        var n = this.pack(packIndex).count;
        var lead = this.state.mix[0];
        var out = [];
        for (var i = 0; i < n; i++) out.push(this.s.allowMix && this.scents.length > 1 ? (this.state.mix[i] || lead) : lead);
        return out;
      }

      variantFor(packIndex) { return this.variantForScent(this.state.mix[0]); }

      unitPrice(v, mode) {
        if (!v) return 0;
        if (mode === 'subscribe') {
          if (this.subMode === 'live') {
            var planId = Number(this.state.plan);
            var alloc = (v.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === planId; });
            if (alloc) return alloc.price;
          } else if (this.subMode === 'preview') {
            return v.price * (1 - (this.s.previewDiscount || 0) / 100);
          }
        }
        return v.price;
      }

      priceFor(packIndex, mode) {
        mode = mode || this.state.mode;
        var self = this;
        var pk = this.pack(packIndex);
        var subtotal = this.canisters(packIndex).reduce(function (sum, key) { return sum + self.unitPrice(self.variantForScent(key), mode); }, 0);
        return Math.round(subtotal * (1 - (pk.discount || 0) / 100));
      }

      basePerCanister() {
        if (this.s.referencePrice > 0) return this.s.referencePrice;
        var v = this.variantFor();
        return v ? v.price : 0;
      }

      cadenceName() {
        var id = String(this.state.plan);
        var p = this.plans.find(function (x) { return String(x.id) === id; });
        return p ? p.name : '';
      }

      update() {
        var self = this;
        var s = this.s;
        var pk = this.pack();
        var n = pk.count;
        var lead = this.scent(this.state.mix[0]);
        var variant = this.variantFor(this.state.pack);
        var price = this.priceFor(this.state.pack);
        var oncePrice = this.priceFor(this.state.pack, 'once');
        var base = Math.round(this.basePerCanister() * n);
        var saving = Math.max(0, base - price);

        // Scent buttons
        this.$$('[data-hf-scent]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hf-scent') === lead.key)); });
        var desc = this.$('[data-hf-scent-desc]');
        if (desc) desc.textContent = lead.desc || '';

        // Pack buttons
        var basePer = this.basePerCanister();
        this.$$('[data-hf-pack]').forEach(function (b) {
          var i = Number(b.getAttribute('data-hf-pack'));
          var p = self.pack(i);
          var pp = self.priceFor(i);
          b.setAttribute('aria-pressed', String(i === self.state.pack));
          var u = b.querySelector('[data-hf-unit]');
          var sv = b.querySelector('[data-hf-save]');
          if (u) u.innerHTML = fill(s.unitText, { price: self.money(pp / p.count) });
          if (sv) {
            var save = Math.round(basePer * p.count) - pp;
            sv.innerHTML = save > 0 ? fill(s.saveText, { amount: self.money(save) }) : esc(s.startText);
          }
        });

        // Mix and match selects
        var mix = this.$('[data-hf-mix]');
        if (mix) {
          if (s.allowMix && n > 1 && this.scents.length > 1) {
            var html = '';
            for (var i = 0; i < n; i++) {
              html += '<label>' + esc(fill(s.mixLabel, { n: i + 1 })) + '<select data-hf-mix-select="' + i + '" aria-label="' + esc(fill(s.mixLabel, { n: i + 1 })) + '">' +
                this.scents.map(function (sc) { return '<option value="' + esc(sc.key) + '"' + (sc.key === self.state.mix[i] ? ' selected' : '') + '>' + esc(sc.name) + '</option>'; }).join('') +
                '</select></label>';
            }
            mix.innerHTML = html;
            mix.hidden = false;
          } else {
            mix.innerHTML = '';
            mix.hidden = true;
          }
        }

        // Purchase options
        var subOpt = this.$('[data-hf-sub-option]');
        var onceOpt = this.$('[data-hf-once-option]');
        if (subOpt) subOpt.classList.toggle('is-active', this.state.mode === 'subscribe');
        if (onceOpt) onceOpt.classList.toggle('is-active', this.state.mode === 'once');
        this.$$('input[name="hf-purchase-' + this.cfg.sectionId + '"]').forEach(function (r) { r.checked = r.value === self.state.mode; });
        var details = this.$('[data-hf-sub-details]');
        if (details) details.hidden = this.state.mode !== 'subscribe';
        var cadence = this.$('[data-hf-cadence]');
        if (cadence && this.state.plan != null) cadence.value = this.state.plan;
        var subPriceEl = this.$('[data-hf-sub-price]');
        if (subPriceEl) {
          var sp = this.priceFor(this.state.pack, 'subscribe');
          subPriceEl.innerHTML = (sp < oncePrice ? '<del>' + this.money(oncePrice) + '</del>' : '') + this.money(sp);
        }
        var oncePriceEl = this.$('[data-hf-once-price]');
        if (oncePriceEl) oncePriceEl.innerHTML = this.money(oncePrice);

        // Totals and button
        var tokens = {
          price: this.money(price),
          savings: this.money(saving),
          pack: pk.label || '',
          count: n,
          cadence: this.cadenceName().charAt(0).toLowerCase() + this.cadenceName().slice(1),
          shipping: price >= s.freeShipThreshold ? s.freeShipText : s.paidShipText
        };
        var totalDesc = this.$('[data-hf-total-desc]');
        if (totalDesc) totalDesc.innerHTML = esc(pk.label) + (saving > 0 && pk.label ? ' &middot; ' : '') + (saving > 0 ? fill(s.totalSaveText, tokens) : '');
        var total = this.$('[data-hf-total]');
        if (total) total.innerHTML = (saving > 0 ? '<del>' + this.money(base) + '</del>' : '') + this.money(price);

        var available = !!variant && this.canisters(this.state.pack).every(function (k) { var cv = self.variantForScent(k); return cv && cv.available !== false; });
        var label = available ? fill(s.addLabel, tokens) : esc(s.soldOutLabel);
        this.$$('[data-hf-add],[data-hf-sticky-add]').forEach(function (b) { b.innerHTML = label; b.disabled = !available; });

        var terms = this.$('[data-hf-terms]');
        if (terms) terms.innerHTML = fill(this.state.mode === 'subscribe' && this.subMode !== 'off' ? s.subTerms : s.onceTerms, tokens);

        // Bundle contents (mini accordion)
        var contents = this.state.mix.slice(0, n).map(function (k, i) { return fill(s.mixLabel, { n: i + 1 }) + ': ' + self.scent(k).name; });
        if (!s.allowMix || n === 1) contents = [n + ' x ' + lead.name];
        this.$$('[data-hf-bundle-contents]').forEach(function (el) { el.textContent = contents.join(' · '); });

        // Upgrade callout
        var callout = this.$('[data-hf-callout]');
        if (callout) {
          var nextIndex = -1;
          this.packs.forEach(function (p, i) { if (p.count > n && (nextIndex === -1 || p.count < self.packs[nextIndex].count)) nextIndex = i; });
          if (nextIndex > -1) {
            var next = this.packs[nextIndex];
            var diff = this.priceFor(nextIndex) - price;
            callout.innerHTML = '<div><strong>' + esc(pk.upgradeHeading || s.calloutHeading) + '</strong><p>' +
              fill(s.calloutText, { next_count: next.count, diff: this.money(Math.max(0, diff)), shipping: tokens.shipping }) +
              '</p></div><button type="button" data-hf-upgrade="' + nextIndex + '">' + esc(fill(s.calloutButton, { next_count: next.count })) + '</button>';
          } else {
            callout.innerHTML = '<div><strong>' + esc(s.calloutMaxHeading) + '</strong><p>' + fill(s.calloutMaxText, { unit: this.money(price / n) }) + '</p></div>';
          }
          callout.hidden = !s.showCallout;
        }

        // Sticky bar
        var sd = this.$('[data-hf-sticky-details]');
        if (sd) {
          var countLabel = n + ' ' + (n === 1 ? s.unitSingular : s.unitPlural);
          sd.textContent = countLabel + ' · ' + (this.state.mode === 'subscribe' && this.subMode !== 'off' ? this.cadenceName() : s.oneTimeShort);
        }

        // Hidden form fields
        var idInput = this.$('form.hf-form input[name="id"]');
        if (idInput && variant) idInput.value = variant.id;
        var planInput = this.$('form.hf-form input[name="selling_plan"]');
        if (planInput) planInput.value = this.state.mode === 'subscribe' && this.subMode === 'live' ? this.state.plan : '';

        this.updateGallery();
      }

      updateGallery() {
        var lead = this.scent(this.state.mix[0]);
        var key = this.state.gallery;
        if (!this.$('[data-hf-slide="' + key + '"]')) key = this.state.gallery = 'product';
        this.$$('[data-hf-slide]').forEach(function (el) { el.hidden = el.getAttribute('data-hf-slide') !== key; });
        this.$$('[data-hf-thumb]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-hf-thumb') === key)); });
        var img = this.$('[data-hf-lead-image]');
        if (img && lead.image) { img.src = lead.image; img.alt = lead.alt || lead.name; }
        var thumb = this.$('[data-hf-lead-thumb]');
        if (thumb && (lead.thumb || lead.image)) { thumb.src = lead.thumb || lead.image; thumb.alt = lead.alt || lead.name; }
        var lbl = this.$('[data-hf-lead-label]');
        if (lbl) lbl.textContent = lead.name;
      }

      lineProperties() {
        var s = this.s;
        var n = this.pack().count;
        var props = {};
        var lead = this.scent(this.state.mix[0]);
        if (s.allowMix && n > 1 && this.scents.length > 1) {
          for (var i = 0; i < n; i++) props[fill(s.mixLabel, { n: i + 1 })] = this.scent(this.state.mix[i]).name;
        } else if (this.scentOptionIndex === -1 && lead.name) {
          props[s.singlePropLabel || 'Scent'] = lead.name;
        }
        return props;
      }

      async addToCart() {
        var variant = this.variantFor(this.state.pack);
        var err = this.$('[data-hf-error]');
        if (err) { err.hidden = true; err.textContent = ''; }
        if (!variant) return;
        var buttons = this.$$('[data-hf-add],[data-hf-sticky-add]');
        buttons.forEach(function (b) { b.disabled = true; b.setAttribute('aria-busy', 'true'); });

        var self = this;
        var data = null;
        var items = [];
        if (this.scentOptionIndex === -1) {
          // Fallback: product has no Scent option, so record scents as line item properties.
          items.push({ id: variant.id, quantity: this.pack().count, properties: this.lineProperties() });
        } else {
          var byId = {};
          this.canisters(this.state.pack).forEach(function (k) {
            var v = self.variantForScent(k);
            if (!byId[v.id]) { byId[v.id] = { id: v.id, quantity: 0 }; items.push(byId[v.id]); }
            byId[v.id].quantity += 1;
          });
        }
        if (this.state.mode === 'subscribe' && this.subMode === 'live' && this.state.plan) {
          items.forEach(function (it) { it.selling_plan = Number(self.state.plan); });
        }

        // Horizon's cart system (@shopify/events). Falls back gracefully on other themes.
        var Events = null;
        try { Events = await import('@shopify/events'); } catch (e) { Events = null; }
        var CLU = Events && Events.CartLinesUpdateEvent;
        var sectionIds = Array.prototype.slice.call(document.querySelectorAll('cart-items-component'))
          .map(function (el) { return el.dataset && el.dataset.sectionId; }).filter(Boolean);
        var itemCount = items.reduce(function (sum, it) { return sum + it.quantity; }, 0);
        var deferred = null;
        if (CLU && typeof CLU.createPromise === 'function') {
          deferred = CLU.createPromise();
          this.dispatchEvent(new CLU({
            action: 'add',
            context: 'product',
            lines: items.map(function (it) { return { merchandiseId: String(it.id), quantity: it.quantity }; }),
            promise: deferred.promise
          }));
        }
        var detailBase = { source: 'hf-product-builder', sourceId: String(this.cfg.sectionId), itemCount: itemCount, productId: String(this.product.id) };
        var getCart = function () {
          return fetch(self.cfg.cartUrl + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' }).then(function (r) { return r.json(); });
        };

        try {
          var body = { items: items };
          if (sectionIds.length) body.sections = sectionIds.join(',');
          var res = await fetch(this.cfg.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            credentials: 'same-origin',
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (!res.ok || data.status) {
            var errMsg = data.description || data.message || 'Could not add to cart';
            if (deferred) getCart().then(function (c) { deferred.resolve({ cart: CLU.createCartFromAjaxResponse(c), detail: Object.assign({ didError: true, items: c.items }, detailBase) }); }).catch(deferred.reject);
            throw new Error(errMsg);
          }

          if (this.s.afterAdd === 'cart') { window.location.href = this.cfg.cartUrl; return; }

          var cart = await getCart();
          if (deferred) {
            deferred.resolve({
              cart: CLU.createCartFromAjaxResponse(cart),
              detail: Object.assign({ items: cart.items, sections: data.sections, didError: false }, detailBase)
            });
          } else {
            document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: this.cfg.sectionId, data: Object.assign({ itemCount: cart.item_count }, detailBase) } }));
          }

          // Open the drawer (Horizon: <theme-drawer id="cart-drawer">). No drawer on the page -> cart page.
          var drawer = document.querySelector('theme-drawer#cart-drawer') || document.querySelector('cart-drawer-component, cart-drawer');
          if (drawer) {
            setTimeout(function () {
              try { if (!drawer.isOpen && typeof drawer.open === 'function') drawer.open(); } catch (e) {}
            }, 250);
          } else {
            window.location.href = this.cfg.cartUrl;
            return;
          }
        } catch (e) {
          if (deferred && !data) deferred.reject(e);
          if (err) { err.textContent = e.message; err.hidden = false; }
        } finally {
          buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
          this.update();
        }
      }

      setupSticky() {
        var bar = this.$('[data-hf-sticky]');
        var main = this.$('[data-hf-add]');
        if (!bar || !main || !('IntersectionObserver' in window)) return;
        this.stickyObserver = new IntersectionObserver(function (entries) {
          var e = entries[0];
          bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
        }, { threshold: 0 });
        this.stickyObserver.observe(main);
      }
    });
  }
})();
